module.exports = __webpack_public_path__ + "img/drop.41337b8a.png";